export default (): void => {
  const contectPGPTiles = (): void => {
    const productGridTile = document.querySelectorAll(".product-tile, .grid-item .card");

    productGridTile.forEach((tile): void => {
      let primaryImage = tile.querySelector(".product-image");
      let loader = tile.querySelector(".spinner");
      let primaryHref = tile.querySelector(".tile-link");

      if (primaryImage !== null) {
        if (loader !== null) {
          if (!primaryImage.complete) {
            loader.classList.add("d-block");
          }
        }

        primaryImage.addEventListener("lazyloading", (): void => {
          if (loader !== null) {
            loader.classList.add("d-block");
          }

          tile.classList.add("processing-item");
        });

        primaryImage.addEventListener("load", (): void => {
          if (!primaryImage.classList.contains("lazy-src") && loader !== null) {
            loader.classList.remove("d-block");
          }

          tile.classList.remove("processing-item");
        });

        let swatches = tile.querySelectorAll(".swatch") || [];
        let imgSwap = (e: Event): void => {
          let swatch = e.target;

          if (swatch) {
            let findActive = tile.querySelector(".swatch.active");
            let imgSrc = swatch.getAttribute("data-img-src");
            let vHref = swatch.getAttribute("href");
            let qvDataURL = swatch.dataset.quickviewUrl;

            if (findActive) findActive.classList.remove("active");

            swatch.classList.add("active");
            primaryImage.setAttribute("src", imgSrc);

            if (vHref !== null) {
              primaryHref.setAttribute("href", vHref);
            }

            if (qvDataURL !== null) {
              primaryHref.dataset.quickviewUrl = qvDataURL;
            }
          }

          if (loader) {
            loader.classList.add("d-block");
          }
        };

        swatches.forEach((swatch): void => {
          swatch.addEventListener("mouseenter", imgSwap);
          swatch.addEventListener("click", (e: Event): void => {
            e.preventDefault();

            return imgSwap.apply(null, arguments);
          });
        });
      }
    });
  };

  document.addEventListener("DOMContentLoaded", contectPGPTiles);
  document.addEventListener("reconnectpgptiles", contectPGPTiles);

  //Reset refinement checkboxes
  document.addEventListener("DOMContentLoaded", (): void => {
    const refinements = document.querySelectorAll(".refinement");

    refinements.forEach((refinement): void => {
      let checkedboxes = refinement.querySelectorAll("input[checked]");

      if (checkedboxes) {
        checkedboxes.forEach((checkbox): void => {
          checkbox.removeAttribute("checked");

          checkbox.checked = true;
        });
      }
    });
  });

  //Generic lazy-loader
  const lazyLoaderImgs = (): void => {
    const lazyImgs = document.querySelectorAll(".lazy-src");
    const lazyload = new Event("lazyload");
    const loading = new Event("lazyloading");
    const loaded = new Event("lazyloaded");

    const fetchImage = (url, image) => {
      return new Promise((resolve, reject) => {
        image.src = url;
        image.onload = resolve;
        image.onerror = reject;

        image.classList.remove("lazy-src");
      });
    };

    const loadImage = (image) => {
      const src = image.dataset.src;

      image.dispatchEvent(loading);

      fetchImage(src, image).then(() => {
        image.classList.add("lazy-loaded");
        image.dispatchEvent(loaded);
      })
    }

    const options = {
      rootMargin: '0px',
      threshold: 0.2
    };

    const handleIntersection = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          loadImage(entry.target);

          observer.unobserve(entry.target);
        }
      })
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    lazyImgs.forEach((lazyImg): void => {
      lazyImg.addEventListener("lazyload", (e): void => {
        observer.observe(lazyImg);
      });

      if (!lazyImg.classList.contains("lazy-customevent")) {
        lazyImg.dispatchEvent(lazyload);
      }
    });
  };

  document.addEventListener("DOMContentLoaded", lazyLoaderImgs);
  document.addEventListener("reconnectpgptiles", lazyLoaderImgs);
};
